import FaqList from './FaqList';
import {createRoot} from "react-dom/client";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import React from "react";
import {I18nextProvider} from "react-i18next";
import i18n from "@apps/Shared/translation/i18n";
const container = document.getElementById('js-faq-app')!;
const hiddenInput = container?.querySelector('.js-faq-app');
const id = Number((hiddenInput as HTMLInputElement).value);
const root = createRoot(container);
const queryClient = new QueryClient();
if(container && id) {
    root.render(
        <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
                <FaqList id={id}/>
            </I18nextProvider>
        </QueryClientProvider>
    );
}